import React from 'react';
import { injectStripe } from 'react-stripe-elements';
import { Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { Container, Row, Col, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Link from 'gatsby-link';
import { CardElement } from 'react-stripe-elements';
import Spinner from '../../components/spinner/spinner';

var serverHost = `${process.env.GATSBY_REALFORCE_SERVER_URL}`
var purchaseUrl = serverHost + "/api/v2.0/license/purchase";
const edition_essential = 'essential';
const edition_professional = 'professional';
const edition_enterprise = 'enterprise';

/**
 * Returns the edition from the url assuming it is the only parameter. If anything goes wrong,
 * return undefiend. This is very primitive but does the job for our purpose.
 */
var getEdition = function () {
    var edition = edition_essential;
    try {
        if (document) {
            var parser = document.createElement('a');
            parser.href = location.href;
            edition = parser.search;
            if (edition) {
                edition = edition.substring(1).split(',');
                edition = edition[0].split('=')[1];
            }
        }

        if (edition !== edition_essential && edition !== edition_professional && edition !== edition_enterprise) {
            edition = edition_essential;
        }
    } catch (error) {
        console.error(error);
    }
    return edition;
}

var getUnitPrice = function (edition, quantity) {
    var basePrice = 0;
    var basePrice = 0;
    if (edition === edition_essential) {
        basePrice = 129;

    } else if (edition === edition_professional) {
        basePrice = 499;

    } else if (edition === edition_enterprise) {
        basePrice = 999;

    } else {
        //else we will assume essential
        basePrice = 129;
    }

    var discountMultiplier = 1;
    if (quantity == 1) {
        discountMultiplier = 1

    } else if (quantity > 1 && quantity <= 4) {
        discountMultiplier = 0.9;

    } else if (quantity > 4 && quantity <= 9) {
        discountMultiplier = 0.85;

    } else if (quantity > 10 && quantity <= 19) {
        discountMultiplier = 0.8;

    } else {
        discountMultiplier = 0.75;
    }

    return Math.floor(basePrice * discountMultiplier);
}

var getTotalPrice = function (edition, quantity) {
    return getUnitPrice(edition, quantity) * quantity;
}

var getEditionName = function (edition) {
    if (edition === edition_essential) {
        return 'Essential';

    } else if (edition === edition_professional) {
        return 'Professional';

    } else if (edition === edition_enterprise) {
        return 'Enterprise';

    } else {
        throw new Error('Unknown edition ' + edition);
    }
}

var isBlank = function(value) {
    if (!value) {
        return true;
    }

    if (value === '') {
        return true;
    }

    return false;
}

var readBody = function(resp) {
    return new Promise((resolve, reject) => {
        resp.text().then((body) => {
            const apiResp = {};
            apiResp.url = resp.url;
            apiResp.status_code = resp.status;

            if (!isBlank(body)) {
                apiResp.body = JSON.parse(body);
            }

            resolve(apiResp);
        }).catch(reject);
    });
}

class CheckoutForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            edition: getEdition(),
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            company: '',
            card_name: '',
            quantity: 1,
            processingError: false,
            processingErrorMessage: '',
            contactError: false,
            contactErrorMessage: '',
            paymentError: false,
            paymentErrorMessage: '',
            purchaseCompleted: false,
            licenseKey: '',
            activationKey: '',
            paymentProcessing: false,
            paymentDetailsComplete: false,
            paymentDetailsMessage: ''
        }
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleOnChangePaymentDetails = this.handleOnChangePaymentDetails.bind(this);
    }

    handleOnChange(event) {
        this.setState(Object.assign(this.state, { [event.target.name]: event.target.value }));
    }

    handleOnChangePaymentDetails(changeObj) {
        this.setState(Object.assign(this.state, { paymentDetailsComplete: changeObj.complete, paymentDetailsMessage: changeObj.error ? changeObj.error.message : ''}));
    }

    handleSubmit = (ev) => {
        // We don't want to let default form submission happen here, which would refresh the page.
        ev.preventDefault();

        var state = this.state;
        if (state.first_name === '') {
            this.setState(Object.assign(state, { contactError: true, contactErrorMessage: 'Please enter Contact First Name' }));
            return;
        }
        
        if (state.last_name === '') {
            this.setState(Object.assign(state, { contactError: true, contactErrorMessage: 'Please enter Contact Last Name' }));
            return;
        }

        if (state.email === '') {
            this.setState(Object.assign(state, { contactError: true, contactErrorMessage: 'Please enter Contact Email' }));
            return;
        }

        if (state.phone === '') {
            this.setState(Object.assign(state, { contactError: true, contactErrorMessage: 'Please enter Contact Phone' }));
            return;
        }

        if (state.first_name === '' || state.last_name === '' || state.email === '' || state.phone === '') {
            this.setState(Object.assign(state, { contactError: true, contactErrorMessage: 'Please enter Contact details'}));
            return;
        } else {
            this.setState(Object.assign(state, { contactError: false }));
        }

        if (state.card_name === '') {
            this.setState(Object.assign(state, { paymentError: true, paymentErrorMessage: 'Please enter card holder\'s name'}));
            return;
        } else {
            this.setState(Object.assign(state, { paymentError: false }));
        }

        if (state.paymentDetailsComplete === false) {
            var msg = state.paymentDetailsMessage;
            if (!msg || msg === '') {
                msg = 'Please enter Payment Card details';
            }
            this.setState(Object.assign(state, { paymentError: true, paymentErrorMessage: msg }));
            return;
        } else {
            this.setState(Object.assign(state, { paymentError: false }));
        }

        this.setState(Object.assign(state, { paymentProcessing: true }));

        // Within the context of `Elements`, this call to createToken knows which Element to
        // tokenize, since there's only one in this group.
        this.props.stripe.createToken({ name: state.card_name}).then(({ token }) => {
            var req = {
                first_name: state.first_name,
                last_name: state.last_name,
                email: state.email,
                phone: state.phone,
                company: state.company,
                product: 'realforce',
                edition: state.edition,
                quantity: state.quantity,
                payment_details: JSON.stringify(token)
            };

            fetch(purchaseUrl, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},                
                body: JSON.stringify(req)
            })
            .then(readBody)
            .then(resp => {
                this.setState(Object.assign(state, { paymentProcessing: false }));
                
                if (resp.status_code >= 300) {
                    this.setState(Object.assign(state, { processingError: true, processingErrorMessage: 'Processing of request failed.  ' + resp.body.message}));
                } else {
                    this.setState(Object.assign(state, { purchaseCompleted: true, license: resp.body}));
                }
            }).catch(err => {
                this.setState(Object.assign(state, {
                    paymentProcessing: false, processingError: true, processingErrorMessage: 'Processing of request failed.  ' + err}));
            });
        });
    }

    render() {
        var state = this.state;
        var props = this.props;

        if (!serverHost || serverHost === '' || serverHost === 'undefined')  {
            return (
                <div>
                    serverHost environment var is not appropriately set
                </div>
            );
        }

        if (state.purchaseCompleted === true) {
            return (
                <div>
                    <h2>Realfire Purchase Completed</h2>
                    <p>Thank you for purchasing Realfire. We appreciate your business.</p>
                    <p>Here are the license details. You can activate Realfire using License/Activation Keys. If you need help activating, please see the <Link to="/products/realfire/docs#activation">help page</Link>.</p>
                    <p>Please do not share the license details with unauthorized parties.</p>
                    <p>Email has been sent to <code>{state.email}</code> with same details. If you have any questions, please contact us at <a href={"mailto:support@datasert.com?subject=About License " + state.licenseKey}>support@datasert.com</a>.</p>
                    <div className="license-details">
                        <table>
                            <tbody>
                                <tr>
                                    <th nowrap>Product</th>
                                    <td>{state.license.product}</td>
                                </tr>
                                <tr>
                                    <th nowrap>Quantity</th>
                                    <td>{state.license.quantity}</td>
                                </tr>
                                <tr>
                                    <th nowrap>Purchased on</th>
                                    <td>{state.license.purchased_on}</td>
                                </tr>
                                <tr>
                                    <th nowrap>Renews on</th>
                                    <td>{state.license.renews_on}</td>
                                </tr>
                                <tr>
                                    <th nowrap>License Key</th>
                                    <td>{state.license.license_key}</td>
                                </tr>
                                <tr>
                                    <th nowrap>Activation Key</th>
                                    <td>{state.license.activation_key}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        var options = [];
        for (var i = 1; i <= 100; i++) {
            options.push(<option value={i}>{i}</option>);
        }

        return (
            <form method="POST" onSubmit={this.handleSubmit}>
                <h2>Buy Realfire</h2>
                <p>Please provide product, contact, payment details and place order.  After successful purchase, License/Activation Keys will be displayed and also will be sent in an email.</p>
                <p>If you have any questions, we will be glad to clarify them. Please reach us at <a href="mailto:support@datasert.com">support@datasert.com</a></p>
                <h5>PO Purchase</h5>
                <p>If you need to purchase via PO, please see the details <Link to="/products/realfire/buypo">here</Link>.</p>

                <div className="payment-section product-details">
                    {
                        state.processingError
                        &&
                        <div className="error-message">{state.processingErrorMessage}</div>
                    }
                    <h4>Product Details</h4>
                    <Input type="select" name="edition" id="edition" onChange={this.handleOnChange} value={state.edition}>
                        <option value="essential">Realfire Essential</option>
                        <option value="professional">Realfire Professional</option>
                        <option value="enterprise">Realfire Enterprise</option>
                    </Input>
                    <span className='quantity'>Seats</span>
                    <Input type="select" name="quantity" id="quantity" onChange={this.handleOnChange} value={state.quantity}>
                        {options}
                    </Input>
                    <span className='unit-price'> x </span><span>${getUnitPrice(state.edition, state.quantity)}</span>
                </div>
                <div>
                    <p className="total-price-line">Total: <span className="total-price">${getTotalPrice(state.edition, state.quantity)}</span> <span className="per-unit">per year</span></p>
                </div>
                <div className="payment-section license-contact">
                    <h4>Contact Details</h4>
                    {
                        state.contactError
                        &&
                        <div className="error-message">{state.contactErrorMessage}</div>
                    }
                    <Row>
                        <Col><Input className="field-required" type="text" name="first_name" id="first_name" placeholder="First Name" onChange={this.handleOnChange} value={state.first_name} /></Col>
                        <Col><Input className="field-required" type="text" name="last_name" id="last_name" placeholder="Last Name" onChange={this.handleOnChange} value={state.last_name} /></Col>
                    </Row>
                    <Row>
                        <Col><Input className="field-required" type="email" name="email" id="email" placeholder="Email (license will be sent to this email)" onChange={this.handleOnChange} value={state.email} /></Col>
                    </Row>
                    <Row>
                        <Col><Input className="field-required" type="phone" name="phone" id="phone" placeholder="Phone" onChange={this.handleOnChange} value={state.phone} /></Col>
                    </Row>
                    <Row>
                        <Col><Input type="text" name="company" id="company" placeholder="Company" onChange={this.handleOnChange} value={state.company} /></Col>
                    </Row>
                </div>
                <div className="payment-section card-details">
                    <h4>Payment Details</h4>
                    {
                        state.paymentError
                        &&
                        <div className="error-message">{state.paymentErrorMessage}</div>
                    }
                    <Row className="card-name">
                        <Col><Input className="field-required" type="text" name="card_name" id="card_nanme" placeholder="Card Holder's name" onChange={this.handleOnChange} value={state.name} /></Col>
                    </Row>
                    <CardElement style={{
                        base: {
                            fontSize: '18px', color: '#495057', '::placeholder': {
                                color: '#aaa',
                                fontWeight: 'normal'
                            }} 
                    }} onChange={this.handleOnChangePaymentDetails}/>
                </div>
                    
                <div className="payment-section">
                    By placing order, you are agreeing to Realfire <a href="/resources/eula" target="_blank">EULA</a> and <a href="/resources/privacy" target="_blank">Privacy Policy</a>
                </div>
                <div className="payment-section">
                    <Button disabled={state.paymentProcessing} color="primary">{state.paymentProcessing ? "Processing..." : "Place Order"}</Button>
                </div>

                {
                    state.paymentProcessing
                    &&
                    <div className="backdrop">
                        <div className="backdrop-content">
                            <Spinner /> Processing Request. Please wait...
                        </div>
                    </div>
                }
            </form>
        );
    }
}

export default injectStripe(CheckoutForm);


// WEBPACK FOOTER //
// ./src/components/purchase/CheckoutForm.jsx